module.exports = __webpack_public_path__ + "img/8.9eed5a06.jpg";